"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangePickerError = void 0;
var tslib_1 = require("tslib");
// (C) 2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var FormattingUtils_1 = require("../utils/FormattingUtils");
var DateRangePickerErrorComponent = function (props) {
    var dateFormat = props.dateFormat, errorId = props.errorId, intl = props.intl;
    return (react_1.default.createElement("div", { className: "gd-date-range-picker-error-message s-absolute-range-error" },
        react_1.default.createElement(react_intl_1.FormattedMessage, { id: errorId, values: { format: dateFormat || FormattingUtils_1.getLocalizedDateFormat(intl.locale) } })));
};
exports.DateRangePickerError = react_intl_1.injectIntl(DateRangePickerErrorComponent);
//# sourceMappingURL=DateRangePickerError.js.map